module.exports = __webpack_public_path__ + "img/service.535d0250.png";